import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Label } from 'reactstrap';
import { Select } from 'antd';
// Local deps
import './RFFSelectField.scss';

const Option = Select.Option;

class RFFSelectField extends React.Component {
  // static initialState = {
  //   value: '',
  // };
  // state = RFFSelectField.initialState;


  // componentWillReceiveProps(nextProps) {
  //   console.log('---nextProps--->', nextProps.input.value);
  //   this.setState({
  //     value: '',
  //   })
  // }
  render() {


    const {
      input,
      meta,
      labelCol,
      inputCol,
      errorCol,
      label,
      isRequired,
      ...otherProps,
    } = this.props;

    const _OnChange = value => {
      if (input.name === 'accessLevel' || input.name === 'ui') {
        // input.value.selectValueA = value;
        input.onChange({ displayValues: input.value.displayValues, selectValueA: value });
        enableButton();
      } else if (input.name === 'category' || input.name === 'qup') {
        // input.value.selectValueC = value;
        input.onChange({ displayValues: input.value.displayValues, selectValueC: value });
        enableButton();
      } else if (input.name === 'visibility') {
        // input.value.selectValueB = value;
        input.onChange({ displayValues: input.value.displayValues, selectValueB: value });
        enableButton();
      }
      // this.setState({ value });
    };

    const enableButton = () => {
      if (document.getElementById("button")) {
        document.getElementById("button").disabled = false;
        document.getElementById("button").className = "nf-button nf-button--form nf-button--orange btn btn-secondary";
      }
    };

    return (

      <div className="nf-rff-input-field">
        <Row className="nf-rff-input-field__row">
          {/* <!-- LABEL --> */}
          {label && (
            <Col {...labelCol}>
              <Label className="nf-rff-input-field__label" htmlFor={input.name}>
                {label}
                {isRequired && (
                  <span className="nf-rff-input-field__required">*</span>
                )}
              </Label>
            </Col>
          )}

          {/* <!-- INPUT --> */}
          <Col {...inputCol}>
            <Select value={input.value.selectValueB === false ? false : input.value.selectValueA || input.value.selectValueB || input.value.selectValueC}
              className="nf-rff-input-field__input"
              onChange={_OnChange}
              {...otherProps}
            >
              {input && input.value.displayValues.map(option => (
                <Option value={option.value} key={option.value} >
                  {input.name === 'category' || input.name === 'qup' || input.name === 'ui' ? (`${option.value} - ${option.text}`) : option.text}
                </Option>
              ))}
            </Select>
          </Col>

          {/* <!-- ERROR -> */}
          {meta.touched &&
            meta.error && (
              <Col {...errorCol}>
                <div className="nf-rff-input-field__error">{meta.error}</div>
              </Col>
            )}
        </Row>


      </div>
    );
  }
}


RFFSelectField.defaultProps = {
  label: '',
  labelCol: { md: 3 },
  inputCol: { md: 6, className: 'text-left' },
  errorCol: { md: 3 },
  isRequired: false,
  mode: '',
  defaultValue: [],
};

RFFSelectField.propTypes = {
  input: PropTypes.object.isRequired, // Supplied by React Final Form
  meta: PropTypes.object.isRequired, // Supplied by React Final Form,
  labelCol: PropTypes.object,
  inputCol: PropTypes.object,
  errorCol: PropTypes.object,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  mode: PropTypes.string,
  defaultValue: PropTypes.string,
};

export default RFFSelectField;



// WEBPACK FOOTER //
// ./src/components/form/RFFSelectField/RFFSelectField.jsx